export type SnippetPathTree = {
  path: string;
  children: SnippetPathTree[];
};

/**
 *
 * @param strPaths An array of all snippet paths associated with a base-level snippet
 * @param baseLevelSnipId Base-level snippet ID
 * @returns Tree where each node represents a snippet and contains a field listing out that snippet's children.
 * This tree is used to dictate the nesting we see upon expanding a base-level snippet.
 */
export const getSnippetPathTree = (strPaths: string[], baseLevelSnipId: string) => {
  const paths = strPaths.map((s) => s.split('/'));
  const maxLevels = paths.reduce((maxLength, arr) => Math.max(maxLength, arr.length), 0);

  const getTree = (path: string, level = 1): SnippetPathTree => {
    if (paths.length === maxLevels) return { path, children: [] as SnippetPathTree[] };
    const children = paths.filter(
      (p) => p.length === level + 1 && p.slice(-level).join('/') === path,
    );
    return { path, children: children.map((c) => getTree(c.join('/'), level + 1)) };
  };

  return getTree(baseLevelSnipId);
};
